import { render, staticRenderFns } from "./UiStringlist.vue?vue&type=template&id=a70aa670&scoped=true"
import script from "./UiStringlist.vue?vue&type=script&lang=js"
export * from "./UiStringlist.vue?vue&type=script&lang=js"
import style0 from "./UiStringlist.vue?vue&type=style&index=0&id=a70aa670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70aa670",
  null
  
)

export default component.exports